import {Dispatcher} from "../../../stem-core/src/base/Dispatcher";
import {NOOP_FUNCTION} from "../../../stem-core/src/base/Utils";


export const SUBSCRIBE_PLAN_STATE = {
    subscribe: "subscribe",
    editSubscription: "editSubscription",
};

class SubscribePlanController extends Dispatcher {
    discountCode = null;
    subscribePlanState = null;
    shareName = true;
    selectedOffer = null;
    applyPolicy = null;
    onSelectSuccess = NOOP_FUNCTION;
    onSelectCancel = NOOP_FUNCTION;
    onCancel = NOOP_FUNCTION;

    update(props) {
        Object.assign(this, props);
        this.dispatch();
    }
}

export const subscribePlanController = new SubscribePlanController();
